import React from 'react'
import {
    AspectRatio,
    Box,
    Skeleton as ChakraSkeleton,
    Stack,
    useMultiStyleConfig
} from '@chakra-ui/react'

// Component Skeleton
const Skeleton = (props) => {
    const styles = useMultiStyleConfig('ProductTile')
    return (
        <Box data-testid="sf-product-tile-skeleton" {...props}>
            <Stack spacing={2}>
                <Box {...styles.imageWrapper}>
                    <AspectRatio ratio={1} {...styles.image}>
                        <ChakraSkeleton />
                    </AspectRatio>
                </Box>
                <ChakraSkeleton width="50%" height="20px" />
                <ChakraSkeleton width="100%" height="12px" />
            </Stack>
        </Box>
    )
}

export default Skeleton
